import React, { useState, useEffect, forwardRef } from 'react';
import { motion } from 'framer-motion';

export const Scene5 = forwardRef(function Scene5(props, ref) {
  const [phase, setPhase] = useState(0);

  useEffect(() => {
    const timers = [
      setTimeout(() => setPhase(1), 500),
      setTimeout(() => setPhase(2), 1500),
      setTimeout(() => setPhase(3), 2500),
    ];
    return () => timers.forEach(t => clearTimeout(t));
  }, []);

  return (
    <motion.div
      ref={ref}
      className="absolute inset-0 flex flex-col items-center justify-center bg-[#004D35]"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 1 }}
    >
      {/* Gold accent line */}
      <motion.div
        className="absolute top-0 left-0 right-0 h-1 bg-[#C5A431]"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
        style={{ transformOrigin: 'left' }}
      />

      <div className="text-center">
        <motion.h1
          className="text-8xl md:text-9xl font-bold text-white"
          style={{ fontFamily: 'Playfair Display, serif' }}
          initial={{ opacity: 0, scale: 1.2, filter: 'blur(12px)' }}
          animate={phase >= 1 ? { opacity: 1, scale: 1, filter: 'blur(0px)' } : { opacity: 0, scale: 1.2, filter: 'blur(12px)' }}
          transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
        >
          Viysr
        </motion.h1>

        <motion.p
          className="text-2xl md:text-3xl text-[#C5A431] mt-6 tracking-wide"
          style={{ fontFamily: 'Playfair Display, serif', fontStyle: 'italic' }}
          initial={{ opacity: 0, y: 20 }}
          animate={phase >= 2 ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.9 }}
        >
          Your business. Expert-guided.
        </motion.p>

        <motion.div
          className="flex items-center justify-center gap-3 mt-10"
          initial={{ opacity: 0 }}
          animate={phase >= 3 ? { opacity: 1 } : { opacity: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="h-px w-16 bg-white/20" />
          <span className="text-white/50 text-sm tracking-widest uppercase">San Diego</span>
          <div className="h-px w-16 bg-white/20" />
        </motion.div>
      </div>

      {/* Bottom gold accent */}
      <motion.div
        className="absolute bottom-0 left-0 right-0 h-1 bg-[#C5A431]"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
        style={{ transformOrigin: 'right' }}
      />
    </motion.div>
  );
});
